import { render } from "./VerifyQuestions.vue?vue&type=template&id=14470a1c"
import script from "./VerifyQuestions.vue?vue&type=script&lang=js"
export * from "./VerifyQuestions.vue?vue&type=script&lang=js"

import "./VerifyQuestions.vue?vue&type=style&index=0&id=14470a1c&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__